export default __webpack_public_path__ + "static/media/cfdrcBlueLight.940188f5.png";